import { render, staticRenderFns } from "./TravelSection.vue?vue&type=template&id=46051036&scoped=true"
import script from "./TravelSection.vue?vue&type=script&lang=js"
export * from "./TravelSection.vue?vue&type=script&lang=js"
import style0 from "./TravelSection.vue?vue&type=style&index=0&id=46051036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46051036",
  null
  
)

export default component.exports